import { defineSlotRecipe } from '@chakra-ui/react';
import { switchAnatomy } from '@chakra-ui/react/anatomy';

export const switchSlotRecipe = defineSlotRecipe({
  className: 'chakra-switch',
  slots: switchAnatomy.keys(),
  base: {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      gap: '2.5',
      position: 'relative',
      verticalAlign: 'middle',
      '--switch-diff': 'calc(var(--switch-width) - var(--switch-height))',
      '--switch-x': {
        base: 'var(--switch-diff)',
        _rtl: 'calc(var(--switch-diff) * -1)',
      },
    },
    indicator: {
      position: 'absolute',
      height: 'var(--switch-height)',
      width: 'var(--switch-height)',
      fontSize: 'var(--switch-indicator-font-size)',
      fontWeight: 'medium',
      flexShrink: 0,
      userSelect: 'none',
      display: 'grid',
      placeContent: 'center',
      transition: 'inset-inline-start 0.12s ease',
      insetInlineStart: 'calc(var(--switch-x) - 2px)',
      _checked: {
        insetInlineStart: '2px',
      },
    },
    control: {
      transition: 'all 0.2s ease',
      width: 'var(--switch-width)',
      height: 'var(--switch-height)',
      borderRadius: 'full',
      p: '2px',
      display: 'inline-flex',
      gap: '0.5rem',
      flexShrink: 0,
      justifyContent: 'flex-start',
      cursor: 'pointer',
      position: 'relative',
      backgroundColor: 'switch.background',
      _invalid: {
        outline: '2px solid',
        outlineColor: 'border.error',
        outlineOffset: '2px',
      },
      _checked: {
        bg: 'background.accent',
        borderColor: 'border.accent.active',
      },
      _disabled: {
        opacity: 'disabled',
        cursor: 'not-allowed',
      },
    },
    thumb: {
      // transition: 'transform 0.2s ease',
      width: '20px',
      height: '20px',
      // borderRadius: 'full',
      // bg: 'background.primary',
      // boxShadow: 'sm',
      // display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'center',
      // flexShrink: 0,
      // transitionProperty: 'translate',
      // transitionDuration: 'fast',
      // _checked: {
      //   translate: 'var(--switch-x) 0',
      // },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      transitionProperty: 'translate',
      transitionDuration: 'fast',
      borderRadius: 'inherit',
      bg: 'background.primary',
      _checked: {
        translate: 'var(--switch-x) 0',
      },
    },
  },
  variants: {
    size: {
      md: {
        root: {
          '--switch-width': '48px',
          '--switch-height': '24px',
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
